function CheckoutCourseList(params) {
  this.courseList = params.courseList;
  this.texts = params.texts;
  this.links = params.links;
  this.chosenAgency = params.chosenAgency;
  this.totalDiscounts = params.totalDiscounts;
  this.totalPrice = params.totalPrice;
  this.totalPriceIncVat = params.totalPriceIncVat;
  this.totalFoodVat = params.totalFoodVat;
  this.totalAccommodationVat = params.totalAccommodationVat;
  this.totalOnlineCourseVat = params.totalOnlineCourseVat;
  this.endpoints = params.endpoints;
  this.readonly = params.readonly;
  this.userHasAlreadyBoughtCourse = params.userHasAlreadyBoughtCourse;
  this.userHasAlreadyBoughtOnlineCourse =
    params.userHasAlreadyBoughtOnlineCourse;
  this.userHasAlreadyBoughtProgram = params.userHasAlreadyBoughtProgram;
  this.removeParticipant = params.removeParticipant;
  this.removeCourse = params.removeCourse;
  this.memberHasDiscount = params.memberHasDiscount;
  this.originalPrice = params.originalPrice;
  this.getPrice = params.getPrice;
  this.employeeList = params.employeeList;

  this.deleteItemText = function(eventType) {
    if (eventType === 5) {
      return this.texts.deleteBundle;
    } else if (eventType === 6) {
      return this.texts.deleteProgram;
    }
    return this.texts.deleteCourse;
  };
}

module.exports = CheckoutCourseList;
